<template>
  <div>
    <section-mapa></section-mapa>
    <section-video-institucional></section-video-institucional>
    <section-contadores></section-contadores>
    <div id="informacoes">
      <section-links ></section-links>
      <section-nos></section-nos>
    </div>
    <section-servicos></section-servicos>
    <section-nfse></section-nfse>
    <section-contato></section-contato>
  </div>
</template>
<script>
  import SectionMapa from "./SectionMapa";
  import SectionLinks from "./SectionLinks";
  import SectionServicos from "./SectionServicos";
  import SectionNfse from "./SectionNfse";
  import SectionNos from "./SectionNos";
  import SectionContadores from "./SectionContadores";
  import SectionContato from "./SectionContato";
  import SectionVideoInstitucional from "./SectionVideoInstitucional";
  export default {
    name: "components",
    components: {
      SectionVideoInstitucional,
      SectionContato,
      SectionNos,
      SectionContadores,
      SectionNfse,
      SectionServicos,
      SectionLinks,
      SectionMapa,
    }
  };
</script>
